/*
 * Model for Landlord Profile section
 */

define(["backbone", "messaging/messenger", "modules/shared/adminMenu/adminMenuModel"], function (
  Backbone,
  Messenger,
  AdminMenuModel,
) {
  var KbProfileModel = {};

  Messenger.reqres.setHandler("landlord:admin:menu:items", function () {
    var menuItems = new AdminMenuModel.menuItems([
      { name: "info", label: "admin.title.landlordTitle", default: true }, //selected by default
      { name: "users", label: "admin.title.usersTitle" },
    ]);

    return menuItems;
  });

  Messenger.reqres.setHandler("landlord:admin:menu:style", function () {
    return new AdminMenuModel.menuType({ type: "pills", stacked: true });
  });

  return KbProfileModel;
});
